var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 11.9792C11.8093 11.9792 11.1469 11.7048 10.6585 11.2164C10.1701 10.7281 9.89575 10.0657 9.89575 9.37501C9.89575 8.68434 10.1701 8.02196 10.6585 7.53359C11.1469 7.04521 11.8093 6.77084 12.4999 6.77084C13.1906 6.77084 13.853 7.04521 14.3413 7.53359C14.8297 8.02196 15.1041 8.68434 15.1041 9.37501C15.1041 9.71699 15.0367 10.0556 14.9059 10.3716C14.775 10.6875 14.5832 10.9746 14.3413 11.2164C14.0995 11.4583 13.8124 11.6501 13.4965 11.7809C13.1805 11.9118 12.8419 11.9792 12.4999 11.9792ZM12.4999 2.08334C10.566 2.08334 8.71138 2.85157 7.34393 4.21902C5.97648 5.58648 5.20825 7.44114 5.20825 9.37501C5.20825 14.8438 12.4999 22.9167 12.4999 22.9167C12.4999 22.9167 19.7916 14.8438 19.7916 9.37501C19.7916 7.44114 19.0234 5.58648 17.6559 4.21902C16.2885 2.85157 14.4338 2.08334 12.4999 2.08334Z",
    fill: "#F15A24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f6db75e911763d320092d3e5b5d53042.svg";
export { ForwardRef as ReactComponent };